/**
 * The package's auth middleware only runs in the browser, so without this a signed-out visitor would get a protected page rendered on the server first.
 * The session is resolved on the server already, so the same sign-in redirect can happen there as a plain HTTP redirect.
 */
export default defineNuxtRouteMiddleware((to) => {
    if (import.meta.client || to.meta.requiresAuth !== true) return

    const { session } = useAuth()
    if (session.value) return

    const { signInPath, redirectQueryKey } = useAuthConfig()
    return navigateTo({ path: signInPath, query: { [redirectQueryKey]: to.fullPath } })
})
